import {getUserProfileData} from './GeneralStorage';
import {Platform} from 'react-native';
import DeviceInfo from 'react-native-device-info';
import {HTTP_METHODS, LOG_CLOUDWATCH_EVENT} from './URLConstants';
import {DLog} from './HelperMethods';
import {fetchApi} from './ApiHelper';

export const category = {
  //put your custom event category here
  BLUETOOTH_EVENT: 'Bluetooth_Event',
  OTHER_EVENT: 'Other_Event',
};

const bluetooth_status = {
  //all possible bluetooth statuses
  START_SYNC: 'Started_Syncing',
  NUM_ENTRIES: 'Num_Entries_Found',
  SYNC_SUCCESS: 'Sync_Successful',
  SYNC_FAIL: 'Sync_Failed',
  START_PAIR: 'Started_Pairing',
  PAIR_SUCCESS: 'Pairing_Successful',
  PAIR_FAIL: 'Pairing_Failed',
};

const other_status = {OTHER_STATUS: 'Other_Status'};

//all possible statuses type
export const status = {...bluetooth_status, ...other_status};

export const cloudWatchAnalyticsLogger = async (
  category,
  status,
  description,
) => {
  try {
    const user = await getUserProfileData();

    // PHI boundary: only the pseudonymous numeric user id may leave the device.
    // Never add name, email, phone, DOB, or any reading values here.
    const userInfo = {
      id: user?.id,
    };

    const platformInfo = {
      platform: Platform.OS,
      platformVersion: Platform.Version,
    };

    const appInfo = {
      appVersion: DeviceInfo.getVersion(),
      appBuildNumber: DeviceInfo.getBuildNumber(),
    };

    const params = {
      userInfo,
      platformInfo,
      appInfo,
      category,
      status,
      description,
    };

    fetchApi(HTTP_METHODS.POST, LOG_CLOUDWATCH_EVENT, params)
      .then(response => {
        // DLog('response', response);
      })
      .catch(error => {
        // DLog('LOG_CLOUDWATCH_EVENT--error', error);
      });
  } catch (e) {}
};
